import { useCallback, useRef } from "react";
import { Button, type ButtonPropsType } from "@core/components/ui/Button";
import { useFetchNcfzLogout } from "@features/auth/hooks/mutations/useNcfzLogin";
import { useUiStore } from "@core/stores/uiStore";
import { useAccountStore } from "@core/stores/accountStore";
import { getLogoutUrl } from "@core/utils/urlUtil";

export default function LogoutLink({ className, variant, size }: { className?: string; variant: ButtonPropsType["variant"]; size: ButtonPropsType["size"] }) {
  const network = useUiStore((state) => state.network);
  const account = useAccountStore((state) => state.account);
  const { mutate: fetchNcfzLogout } = useFetchNcfzLogout();
  const formRef = useRef<HTMLFormElement>(null);

  const clickHandler = useCallback(() => {
    // ncfz login되어 있을 경우 logout
    if (account?.ncfzUserInfo?.login) {
      fetchNcfzLogout();
    }

    // plaync logout
    formRef.current?.submit();
  }, [formRef, account]);

  return (
    <>
      <form action={getLogoutUrl(network)} method="post" ref={formRef}>
        <input type="hidden" name="return_url" value={window.location.origin} />
      </form>
      <Button {...{ className, variant, size }} onClick={clickHandler}>
        로그아웃
      </Button>
    </>
  );
}
